import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const LINKS = [
  ['/outreach', 'Overview', true],
  ['/outreach/offices', 'Office directory'],
  ['/outreach/areas', 'Area intelligence'],
  ['/outreach/tracker', 'Outreach tracker'],
  ['/outreach/runs', 'Agent runs'],
  ['/outreach/import', 'Import workbook'],
  ['/outreach/settings', 'Settings'],
];

// Hosts the provider outreach pages inside the unified shell with a section nav.
// Every page below uses the ops design kit; nothing here renders patient data.
export default function OutreachLayout() {
  return (
    <main className="main-content ops-main">
      <div className="ops-page">
        <nav className="ops-tabs" aria-label="Provider outreach sections" style={{ marginBottom: 18 }}>
          {LINKS.map(([to, label, end]) => (
            <NavLink key={to} to={to} end={Boolean(end)} className={({ isActive }) => (isActive ? 'is-active' : '')}>{label}</NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </main>
  );
}
